import { useRouteParam } from '@/common/hooks/useRouteParam';
import type { SideComponentProps } from '@/common/types/app';
import { PageTitle } from '@/components/PageTitle/PageTitle';
import { CreateOffer } from '@/views/CreateOffer/CreateOffer';
import { NewInteractionUnsavedChangesProvider } from '@/views/NewInteraction/NewInteractionUnsavedChangesProvider';

const NewOfferPage: SideComponentProps = () => {
  const sourceId = useRouteParam('sourceId', '');
  const buyerId = useRouteParam('buyerId', '');
  const listingId = useRouteParam('listingId', '');
  const buyerType = useRouteParam('buyerType', '');

  return (
    <>
      <PageTitle title="Create Offer | Side" />
      <NewInteractionUnsavedChangesProvider>
        <CreateOffer
          sourceId={sourceId}
          buyerId={buyerId}
          listingId={listingId}
          buyerType={buyerType}
        />
      </NewInteractionUnsavedChangesProvider>
    </>
  );
};

NewOfferPage.appShellProps = {
  hideInteractionSidebar: true,
};

NewOfferPage.disableInteractionValidation = true;

export default NewOfferPage;
